import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "webhookSection",
    "emailSection",
    "providerSection",
    "providerInput",
    "emailInput",
    "kindRadio",
  ];

  connect() {
    this.toggle();
  }

  toggle() {
    const selected = this.selectedKind;

    if (this.hasWebhookSectionTarget) {
      this.webhookSectionTargets.forEach((el) => {
        el.classList.toggle("hidden", selected !== "webhook");
      });
    }

    if (this.hasEmailSectionTarget) {
      this.emailSectionTargets.forEach((el) => {
        el.classList.toggle("hidden", selected !== "email");
      });
    }

    if (this.hasProviderSectionTarget) {
      this.providerSectionTargets.forEach((el) => {
        el.classList.toggle("hidden", selected !== "webhook");
      });
    }

    if (this.hasEmailInputTarget) {
      this.emailInputTarget.disabled = selected !== "email";
    }

    if (this.hasProviderInputTarget) {
      if (selected === "email") {
        this.providerInputTarget.disabled = true;
        this.providerInputTarget.value = "";
      } else {
        this.providerInputTarget.disabled = false;
      }
    }

    this.updateCardStyles(selected);
  }

  updateCardStyles(selected) {
    this.element.querySelectorAll("[data-kind-card]").forEach((card) => {
      const kind = card.dataset.kindCard;
      if (kind === selected) {
        card.classList.remove(
          "border-gray-200",
          "hover:border-gray-300",
        );
        card.classList.add(
          kind === "email"
            ? "border-purple-500"
            : "border-indigo-500",
          kind === "email" ? "bg-purple-50" : "bg-indigo-50",
        );
      } else {
        card.classList.remove(
          "border-indigo-500",
          "border-purple-500",
          "bg-indigo-50",
          "bg-purple-50",
        );
        card.classList.add("border-gray-200", "hover:border-gray-300");
      }
    });
  }

  get selectedKind() {
    const checked = this.element.querySelector(
      'input[name="endpoint[kind]"]:checked',
    );
    return checked ? checked.value : "webhook";
  }
}
